import { User } from '../../lib/user'
import { FeatureFlags } from '../../context/FeaturesContext'
import { useContext } from 'react';
import { Link } from 'react-router-dom'

type Props = {
  user: User
  className?: string
  type: 'desktop'|'mobile100'|'mobile50'
}

const dimensions = (type: string): {height: number, width: number} => {
  switch(type) {
    case 'mobile50':
      return {height: 50, width: 320}
    case 'mobile100':
      return {height: 100, width: 320}
    case 'desktop':
    default:
      return {height: 600, width: 320}
  }
}

export const Ad = ({ user, className, type }: Props) => {
  const features = useContext(FeatureFlags);
  const showAd = features.ads && !user.hasPolygonlePlus()
  if(!showAd) {
    return <></>
  }
  return <div className={className + " flex flex-col items-center justify-center"}>
    <div style={dimensions(type)}>
    {type === 'desktop' &&  <div className="ympb_target" data-type="desktop-medrec-template" data-subtype="300x250,300x600,160x600,120x600"></div>}
    {type === 'mobile100' && <div className="ympb_target" data-type="mobile-leaderboard-template" data-subtype="300x50,300x100,320x50,320x100" style={{textAlign: "center"}}></div>}
    {type === 'mobile50' && <div className="ympb_target" data-type="mobile-leaderboard-template" data-subtype="300x50,320x50" style={{textAlign: "center"}}></div>}
    </div>
    <Link to="?pplus" className="text-xs font-bold text-amber-600 text-center hover:darken-100">
      remove ads
    </Link>
  </div>
}
